/* eslint no-restricted-syntax: 0 */
/* eslint no-console: 0 */
import React, {
  createContext,
  ReactNode,
  useContext,
  useEffect,
  useState,
} from 'react'
import { makeMe } from '../../main/usecases/me/load-me-factory'
import HelperAmplify from '../helpers/helper-amplify'
import IMe from '../interfaces/me'
import IProfile from '../interfaces/profile'

type IProps = {
  children: ReactNode;
}

type MeContextProps = {
  updateMe: (value: IMe) => void;
  me: IMe | null;
  permissions: Set<unknown>;
  formatPermissions: (profiles: IProfile[] | null | undefined) => Set<unknown>;
}

const MeContext = createContext({} as MeContextProps)

const MeProvider = ({ children }: IProps) => {
  const [me, setMe] = useState<null | IMe>(null)
  const [permissions, setPermissions] = useState<Set<unknown>>(new Set())

  const formatPermissions = (profiles: IProfile[] | null | undefined): Set<unknown> => {
    if (!profiles) return new Set()

    const permissionGroup = new Set()
    for (const profile of profiles) {
      for (const permission of profile.permissions) {
        permissionGroup.add(permission.code)
      }
    }

    return permissionGroup
  }

  const updateMe = (value: IMe) => {
    setMe(value)
    // const stablishmentId = value?.stablishments[0]?.id
    // localStorage.set(stablishmentId, String(stablishmentId))
  }

  useEffect(() => {
    async function loadContext() {
      if (!HelperAmplify.isAuth()) {
        HelperAmplify.signOut()
        return
      }
      try {
        const { user } = await makeMe().load()
        updateMe(user)
      } catch (err) {
        HelperAmplify.signOut()
      }
    }

    loadContext()
  }, [])

  useEffect(() => {
    if (!me) return
    setPermissions(formatPermissions(me?.profiles))
  }, [me])

  return (
    <MeContext.Provider
      value={{
        me,
        updateMe,
        permissions,
        formatPermissions,
      }}
    >
      {children}
    </MeContext.Provider>
  )
}

export const useMe = () => {
  const context = useContext(MeContext)

  if (!context) {
    throw new Error('useMe must be used within a provider MeProvider')
  }

  return context
}

export default MeProvider
